import { useAuth } from 'admin/Auth';
import { Button } from 'antd';
import React from 'react';

const Login: React.FC = () => {
  const { login } = useAuth();
  return (
    <Button
      style={{ fontSize: '12px', letterSpacing: 0 }}
      type="primary"
      onClick={login}
    >
      登录
    </Button>
  );
};

export default Login;
